<template>
  <div>
    <p class="lidaCard-title">网站维护</p>
    <hr />
    <div>
      <h2 class="tc mb-3 mainTainTitle">新增维护</h2>
    </div>
    <table class="TB_COLLAPSE" width="100%">
      <thead>
        <tr>
          <th colspan="3">內容</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>維護時間</td>
          <td>
            <Col>
              開始時間 :
              <DatePicker type="date" placeholder="選擇開始時間" style="width: 160px"></DatePicker>
            </Col>
          </td>
          <td>
            <Col style="align: center">
              結束時間 :
              <DatePicker type="date" placeholder="選擇結束時間" style="width: 146px"></DatePicker>
            </Col>
          </td>
        </tr>
        <tr>
          <td>維護站点</td>
          <td colspan="2">
            <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
              <Checkbox
                :indeterminate="indeterminate"
                :value="checkAll"
                @click.prevent.native="handleCheckAll"
              >全部</Checkbox>
              <Checkbox label="拾貳彩"></Checkbox>
              <Checkbox label="新A6"></Checkbox>
              <Checkbox label="A7"></Checkbox>
              <Checkbox label="鑫博"></Checkbox>
            </CheckboxGroup>
          </td>
        </tr>
        <tr>
          <td>維護公告內文</td>
          <td colspan="2">
            <Input style="width:80%;" type="textarea" :rows="4" placeholder="請輸入維護公告內容..." />
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-right" style="margin-top:6px">
      <Button class="setBackBtn" type="primary" @click="setBackBtn">返回</Button>
      <Button class="setBackBtn" type="error" @click="setBackBtn">新增</Button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      indeterminate: true,
      checkAll: false,
      checkAllGroup: ['拾貳彩', '新A6', 'A7', '鑫博']
    }
  },
  methods: {
    setBackBtn () {
      this.$router.go(-1)
    },
    handleCheckAll () {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false
      if (this.checkAll) {
        this.checkAllGroup = ['拾貳彩', '新A6', 'A7', '鑫博'];
      } else {
        this.checkAllGroup = [];
      }
    },
    checkAllGroupChange (data) {
      if (data.length === 4) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    }
  }
}
</script>
<style>
.lidaCard-title {
  font-weight: bold;
  padding-bottom: 10px;
}
.mainTainTitle {
  color: #1d3c78;
  padding-top: 12px;
}
.setBackBtn {
  margin-left: 10px;
}
</style>